module.exports = __webpack_public_path__ + "static/media/margarita-nikolenko.2125ca1b.jpg";